import { ApiSeo } from 'idt-ecommerce-api/_api/api-web/api-seo/api-seo.models';
import { Seo } from 'idt-ecommerce-api/seo/seo.models';


export class SeoModelsTransformer {

  /* Templates hardcoded in the corefront systems library */
  private static readonly URL_TEMPLATE_CATEGORY = '/{storeId}/[{langId}/][{keyWord}-]c{categoryId}[-{catalogId}].html';
  private static readonly URL_TEMPLATE_PRODUCT = '/{storeId}/[{langId}/][{keyWord}-]c{categoryId}p{productId}[c{initColor}][-{catalogId}].html';

  public static seoFromApi(apiSeo: ApiSeo): Seo {
    return {
      urlTemplates: {
        category: this.URL_TEMPLATE_CATEGORY,
        product: this.URL_TEMPLATE_PRODUCT
      },
      languageUrlCodes: apiSeo.seoParamMap.langId
    };
  }

  /**
   * Normalises a domain input from an external injection channel (RenderSetupData or sessionStorage)
   * to the current Seo shape. Supports two input shapes for backwards compatibility:
   *
   * - **Current shape**: `{ urlTemplates: { category, product }, languageUrlCodes }` — returned as-is.
   * - **Legacy shape** (CMS-7069 injectors pre-rename): `{ pageTemplateRegexMap: { ItxCategoryPage, ItxProductPage },
   *   paramValuesMap: { langId } }` — mapped to the current shape transparently.
   *
   * Returns `undefined` when the input does not match either shape, so the caller can fall back to HTTP.
   */
  public static seoFromDomainInput(input: unknown): Seo | undefined {
    if (!input || typeof input !== 'object') {
      return undefined;
    }

    const raw = input as Record<string, unknown>;

    // Current shape
    if (raw.urlTemplates && raw.languageUrlCodes) {
      const templates = raw.urlTemplates as Record<string, unknown>;
      if (typeof templates.category === 'string' && typeof templates.product === 'string'
        && typeof raw.languageUrlCodes === 'object' && !Array.isArray(raw.languageUrlCodes)) {
        return input as Seo;
      }
    }

    // Legacy shape (pre-rename injectors — CMS-7069)
    if (raw.pageTemplateRegexMap && raw.paramValuesMap) {
      const templateMap = raw.pageTemplateRegexMap as Record<string, unknown>;
      const paramValues = raw.paramValuesMap as Record<string, unknown>;
      const langId = paramValues.langId;

      if (typeof templateMap.ItxCategoryPage === 'string'
        && typeof templateMap.ItxProductPage === 'string'
        && langId && typeof langId === 'object' && !Array.isArray(langId)) {
        return {
          urlTemplates: {
            category: templateMap.ItxCategoryPage as string,
            product: templateMap.ItxProductPage as string
          },
          languageUrlCodes: langId as { [languageId: string]: string }
        };
      }
    }

    return undefined;
  }

}
